import React from "react";
import { FaCalendarAlt, FaComments } from "react-icons/fa";
import { Config } from "../../Config";
import Skeleton from "react-loading-skeleton";
import { Link, withRouter } from "react-router-dom";

const BlogItem = (props) => {
  const showSingleBlog = (id, title) => {
    props.history.push({
      pathname: `/blog/${title.replaceAll(" ", "-")}`,
      state: { blogId: id },
    });
  };

  return (
    <React.Fragment>
      {props.loading ? (
        props.blogItemData.map((item, index) => {
          return (
            <div key={index + 1000} className="blogItem">
              <div className="imageFigure">
                <Skeleton highlightColor={Config.skeletonHighlightColor} width="100%" height="100%" />
              </div>
              <div className="blogDetails">
                <span className="productTitle">
                  <Skeleton highlightColor={Config.skeletonHighlightColor} width="100%" height="100%" />
                </span>
                <p className="blogFooter">
                  <Skeleton highlightColor={Config.skeletonHighlightColor} width="100%" height="100%" />
                </p>
              </div>
            </div>
          );
        })
      ) : (
        <React.Fragment>
          {props.blogItemData.map((item, index) => {
            return (
              <div key={index} className="blogItem">
                <div className="imageFigure">
                  <span onClick={() => showSingleBlog(item.id, item.title)}>
                    <img className="blogImage" src={item.image} alt={item.title} />
                  </span>
                  <div className="blogCategory">
                    {/* <Link to={"/blog/" + item.id} className="categoryLink">
                      {item.blogCategoryName}
                    </Link> */}
                    <span className="categoryLink">{item.blogCategoryName}</span>
                  </div>
                </div>
                <div className="blogDetails">
                  <span onClick={() => showSingleBlog(item.id, item.title)} className="blogTitle">
                    {item.title}
                  </span>
                </div>
                <div className="blogFooter">
                  <div className="blogCreateDate">
                    <p>
                      <FaCalendarAlt /> {item.createDateTime}
                    </p>
                  </div>
                  <div className="blogCommentCount">
                    <p>
                      <FaComments /> {item.blogCommentCount} دیدگاه
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default React.memo(withRouter(BlogItem));
